import React, { useEffect } from "react";
import logo from "../../Assests/handa_logo-1.webp";
import { Link, useLocation } from "react-router-dom";
import {
  FaAngleDown,
  FaFacebookSquare,
  FaInstagramSquare,
} from "react-icons/fa";
import { RiArrowDropDownLine } from "react-icons/ri";
import { Offcanvas } from "bootstrap";
import { TfiLayoutLineSolid } from "react-icons/tfi";

const Navbar = () => {
  const closeOffcanvas = () => {
    const offcanvas = document.getElementById("mobileMenu");

    const bsOffcanvas = window.bootstrap.Offcanvas.getInstance(offcanvas);

    if (bsOffcanvas) {
      bsOffcanvas.hide();
    }
  };
  return (
    <>
      <nav
        className="navbar navbar-expand-lg navbar-dark bg-transparent position-absolute top-0 start-0 w-100 py-3"
        style={{ zIndex: 1000 }}
      >
        <div className="container">
          <Link className="navbar-brand" to="/">
            <img
              src={logo}
              alt="Logo"
              className="img-fluid"
              style={{ maxHeight: "35px" }}
            />
          </Link>

          <button
            className="navbar-toggler border-0 shadow-none"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#mobileMenu"
            aria-controls="mobileMenu"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse d-none d-lg-flex justify-content-end">
            <ul className="navbar-nav align-items-lg-center gap-lg-3">
              <li className="nav-item">
                <Link className="nav-link text-white" to="/">
                  Home
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link text-white" to="/about-us">
                  About Us
                </Link>
              </li>

              <li className="nav-item dropdown dropdown-hover">
                <Link
                  className="nav-link  text-white"
                  to="#"
                  role="button"
                  data-bs-toggle="dropdown"
                >
                  Projects <FaAngleDown />
                </Link>

                <ul className="dropdown-menu border-0 shadow rounded-0 border-top border-primary">
                  <li>
                    <Link className="dropdown-item" to="/dubai-developments">
                      <TfiLayoutLineSolid className="me-2 text-dark" /> Dubai
                      Developments
                    </Link>
                  </li>

                  <li>
                    <Link className="dropdown-item" to="/toronto-developments">
                      <TfiLayoutLineSolid className="me-2 text-dark" /> Toronto
                      Developments
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="nav-item">
                <Link className="nav-link text-white" to="/contact-us">
                  Contact Us
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link text-white fs-5" to="#">
                  <FaFacebookSquare />
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link text-white fs-5" to="#">
                  <FaInstagramSquare />
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <div
        className="offcanvas offcanvas-end text-bg-dark"
        tabIndex="-1"
        id="mobileMenu"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="offcanvas-title">Handa Realtor</h5>

          <button
            type="button"
            className="btn-close btn-close-white shadow-none"
            data-bs-dismiss="offcanvas"
          ></button>
        </div>

        <div className="offcanvas-body">
          <ul className="navbar-nav gap-2">
            <li className="nav-item">
              <Link
                className="nav-link text-white"
                to="/"
                onClick={closeOffcanvas}
              >
                Home
              </Link>
            </li>

            <li className="nav-item">
              <Link
                className="nav-link text-white"
                to="/about-us"
                onClick={closeOffcanvas}
              >
                About Us
              </Link>
            </li>

            <li className="nav-item">
              <div className="text-uppercase text-white small mt-3 mb-2">
                Projects
              </div>
            </li>

            <li className="nav-item ps-2">
              <Link
                className="nav-link text-white"
                to="/dubai-developments"
                onClick={closeOffcanvas}
              >
                <TfiLayoutLineSolid className="me-2 text-white" />
                Dubai Developments
              </Link>
            </li>

            <li className="nav-item ps-2">
              <Link
                className="nav-link text-white"
                to="/toronto-developments"
                onClick={closeOffcanvas}
              >
                <TfiLayoutLineSolid className="me-2 text-white" /> Toronto
                Developments
              </Link>
            </li>

            <li className="nav-item mt-2">
              <Link
                className="nav-link text-white"
                to="/contact-us"
                onClick={closeOffcanvas}
              >
                Contact Us
              </Link>
            </li>

            <li className="nav-item mt-3 d-flex gap-3">
              <Link className="text-white fs-4" to="#">
                <FaFacebookSquare />
              </Link>

              <Link className="text-white fs-4" to="#">
                <FaInstagramSquare />
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Navbar;
